import { createFileRoute } from "@tanstack/react-router";
import SuperLayoutTitle from "@/components/layout/super-layout/super-layout-title";
import { Card } from "@/components/ui/card";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import DataTable, { TableColumn } from "@/components/table/data-table";
import { Doc } from "@/convex/_generated/dataModel";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";
import { es } from "date-fns/locale";

export const Route = createFileRoute("/_super/super/subscriptions")({
  component: SubscriptionsPage,
});

function SubscriptionsPage() {
  return (
    <>
      <SuperLayoutTitle
        title="Gestión de Suscripciones"
        subtitle="Administra todas las suscripciones del sistema"
      />
      <SubscriptionsTable />
    </>
  );
}

const columns: TableColumn<Doc<"company_subscriptions">>[] = [
  {
    key: "companyId",
    label: "Empresa ID",
    render: (value: string) => (
      <div className="text-sm text-muted-foreground font-mono">{value}</div>
    ),
  },
  {
    key: "planId",
    label: "Plan ID",
    render: (value: string) => (
      <div className="font-medium font-mono text-sm">{value}</div>
    ),
  },
  {
    key: "status",
    label: "Estado",
    render: (value: string) => {
      const variants: Record<
        string,
        "default" | "secondary" | "destructive" | "outline"
      > = {
        active: "default",
        trial: "secondary",
        suspended: "destructive",
        canceled: "outline",
      };
      return (
        <Badge variant={variants[value] || "secondary"}>
          {value === "active" && "Activo"}
          {value === "trial" && "Prueba"}
          {value === "suspended" && "Suspendido"}
          {value === "canceled" && "Cancelado"}
        </Badge>
      );
    },
  },
  {
    key: "trialEndsAt",
    label: "Fin de prueba",
    render: (value: number | null) => {
      if (!value) return "-";
      return (
        <div className="text-sm text-muted-foreground">
          {format(new Date(value), "dd MMM yyyy", { locale: es })}
        </div>
      );
    },
  },
  {
    key: "_creationTime",
    label: "Creado",
    sortable: true,
    render: (value: number) => {
      const date = new Date(value);
      return (
        <div className="text-sm text-muted-foreground">
          {format(date, "dd MMM yyyy", { locale: es })}
        </div>
      );
    },
  },
];

function SubscriptionsTable() {
  const subscriptions = useQuery(
    api.companies.subscriptions.queries.getAllSubscriptions,
  );

  if (subscriptions === undefined) {
    return (
      <Card className="p-6">
        <div className="text-center text-muted-foreground">Cargando...</div>
      </Card>
    );
  }

  if (subscriptions === null || subscriptions.length === 0) {
    return (
      <Card className="p-6">
        <div className="text-center text-muted-foreground">
          No hay suscripciones registradas
        </div>
      </Card>
    );
  }

  return (
    <DataTable
      columns={columns}
      data={subscriptions}
      emptyState={{
        title: "No hay suscripciones registradas",
        description: "Las suscripciones aparecerán aquí",
      }}
    />
  );
}
